<template>
    <div class="embedded-page">
        <router-view></router-view>
    </div>
</template>

<script>
import { DISCUSS_DATA_MANAGER } from '../../modules/data';
import { WS } from '../../modules/websocket';
import { DISCUSS_DOM } from '../../modules/dom';
import { UTILS } from '../../modules/utils';
export default {
    name: 'Embedded',
    computed: {
        commentHideName() {
            return this.$store.state.comment.hideName;
        },
        commentShareCode() {
            return this.$store.state.comment.shareCode;
        }
    },
    created: function() {
        var curPath = this.$router.history.current.path,
            curQuery = this.$router.history.current.query;
        console.log('Embedded------created', curPath, curQuery)
        switch(curPath) {
            case '/embedded/comment':
                this.initEmbeddedComment(curQuery);
                break;
            case '/embedded/discusslist':
                this.initEmbeddedDiscuss(curQuery);
                break;
            case '/embedded/discuss':
                this.initEmbeddedSendDiscuss(curQuery);
                break;
            case '/embedded/report':
                this.initEmbeddedReport(curQuery);
                break;
            case '/embedded/label':
                this.initEmbeddedLabel(curQuery);
                break;
            case '/embedded/labelmanage':
                this.initEmbeddedLabelManage(curQuery);
                break;
            case '/embedded/famouspediaread':
                this.initEmbeddedFamousPediaRead(curQuery);
                break;
            case '/embedded/famouspediaedit':
                this.initEmbeddedFamousPediaEdit(curQuery);
                break;
            case '/embedded/famouspediacreate':
                this.initEmbeddedFamousPediaCreate(curQuery);
                break;
            case '/embedded/diagram':
            case '/embedded/diagramrecord':
            case '/embedded/diagramdetail':
            case '/embedded/diagramedit':
                this.initEmbeddedDiagram(curQuery);
                break;
            default:
                break;
        }
    },
    methods: {
        /**
         * 初始化八字信息之后，跳转到初始化批盘逻辑
         */
        initEmbeddedComment(curQuery) {
            var me = this;
            this.$store.dispatch('embedded/initEmbeddedDetailInfo', {
                queryData: curQuery,
                cb: function(data) {
                    console.log('initEmbeddedComment-------', data)
                    // 根据批盘不同的状态，跳转到不同页面
                    if(data.pipan != 0) {
                        me.goToMyComment(data);
                    }else {
                        if(data.otherpipan != 0) {
                            me.$store.dispatch('othercomment/getOtherPiPanList', {
                                detailId: data.id,
                                cb: function() {
                                    me.goToOtherComment(data);
                                }
                            });
                        }else {
                            me.goToMyComment(data);
                        }
                    }
                }
            });
        },
        /**
         * 跳转到我的批盘页面
         */
        goToMyComment(data) {
            this.$store.dispatch('othercomment/getOtherPiPanList', {
                detailId: data.id
            });
            this.$store.dispatch("minifatefortune/resetMiniData");
            this.$store.dispatch('minifatefortune/initCommentMiniFateFortune', data);
            this.$store.state.detail.personInfo = data;
            this.$store.dispatch('comment/resetData');
            this.$store.dispatch('comment/initEmbeddedPiPan', {
                detailData: data,
            });
        },
        goToOtherComment(data) {
            var otherCommentList = this.$store.state.othercomment.otherCommentList,
                otherL = otherCommentList.length,
                otherData = otherL > 0 ? otherCommentList[otherL-1] : undefined;
            console.log('goToOtherComment------', data, otherData)
            if(!otherData) { return; }
            this.$store.dispatch("minifatefortune/resetMiniData");
            this.$store.dispatch('minifatefortune/initCommentMiniFateFortune', data);
            this.$store.dispatch("comment/resetData");
            this.$store.dispatch("comment/initOtherPiPan", {
                detailData: data,
                pipanData: otherData.pipan
            });
            // 他人批盘的分享数据设置
            this.$store.state.comment.otherShareTitle = otherData.title;
            this.$store.state.comment.otherShareCode = otherData.share;
        },
        /**
         * 初始化八字信息之后，跳转到初始化论盘列表逻辑
         */
        initEmbeddedDiscuss(curQuery) {
            var me = this;
            this.$store.dispatch('embedded/initEmbeddedDetailInfo', {
                queryData: curQuery,
                cb: function(data) {
                    // 保存一下token:::在论盘房间使用
                    me.$store.state.userData.token = curQuery.token;
                    me.$store.state.detail.personInfo = data;
                    me.$store.dispatch("discuss/initLunPanList", data);
                }
            })
        },
        /**
         * 初始化八字信息之后，跳转到发起论盘的逻辑
         */
        initEmbeddedSendDiscuss(curQuery) {
            var me = this;
            this.$store.dispatch('embedded/initEmbeddedDetailInfo', {
                queryData: curQuery,
                cb: function(data) {
                    // 保存一下token:::在论盘房间使用
                    me.$store.state.userData.token = curQuery.token;
                    me.$store.state.detail.personInfo = data;

                    me.$store.state.discuss.detailInfo = data;
                    var newTitle = DISCUSS_DATA_MANAGER.getNewLunPanTitle();
                    me.$store.dispatch('discuss/addNewLunPan', {
                        params: {
                            lunpanName: newTitle,
                            lunpanDes: '',
                            public: true,
                            anony: true
                        },
                        cb: function(lunpanData){
                            setTimeout(() => {
                                me.goToDiscussPage(data, lunpanData);
                            }, 100);
                        }
                    });
                }
            })
        },
        /**
         * 
         */
        goToDiscussPage(detailData, lunpanData){
            var me = this;
            // 先重置，再初始化mini命盘的数据
            this.$store.dispatch("minifatefortune/resetMiniData");
            this.$store.dispatch('minifatefortune/initCommentMiniFateFortune', detailData);
            WS.initWebSocket(lunpanData.rid, function() {
                // 初始化论盘数据:聊天记录列表:websocket登录之后再拉取列表数据
                me.$store.dispatch("discuss/initLunPan", {
                    lunpanData: lunpanData,
                    cb: function() {
                        // 设置微信分享配置
                        setTimeout(() => {
                            me.$bus.emit('initDiscussHistoryList');
                            DISCUSS_DOM.updateDiscussPageStyle();
                            DISCUSS_DOM.updateDiscussFormStyle();
                        }, 200);
                        setTimeout(() => {
                            me.$bus.emit('scrollToDiscussBottom');
                            me.$bus.emit('checkDiscussBubbleStatus');
                        }, 1000);
                    }
                });
            })
        },
        /**
         * 初始化八字信息之后，跳转到评测页的逻辑
         */
        initEmbeddedReport(curQuery) {
            console.log('initEmbeddedReport--------', curQuery)
            var me = this;
            let platform = curQuery.os && curQuery.os.toLowerCase().indexOf('android') != -1 ? 2 : 5; //安卓为2,IOS为5
            this.$store.dispatch('embedded/initEmbeddedDetailInfo', {
                queryData: curQuery,
                cb: function(data) {
                    me.$store.state.detail.personInfo = data;
                    me.$store.dispatch('report/initReportAIConfig', {
                        params: Object.assign({platform: platform}, {}),
                        cb: function() {
                            me.$store.dispatch('report/getReportInfo', {
                                detailInfo: data,
                                cb: function() {
                                    console.log('initEmbeddedReport---------', data)
                                }
                            })
                        }
                    });
                }
            });

        },
        initEmbeddedLabel(curQuery) {
            var me = this;
            console.log('init-----', curQuery.from, curQuery.hideTitle)
            switch(curQuery.from) {
                case 'updatelabel':
                    this.$store.state.embedded.hideTitle = curQuery.hideTitle;
                    this.$store.dispatch('embedded/initEmbeddedDetailInfo', {
                        queryData: curQuery,
                        cb: function(data) {
                            me.$store.state.detail.personInfo = data;
                            me.$store.dispatch('label/initLabelList', {
                                cb: function() {
                                    me.$store.dispatch('label/initSelectedLabelFromDetail', data);
                                    me.$store.dispatch('label/updateComfirmedSelectedLabel');
                                }
                            });
                        }
                    });
                    break;
                case 'selectlabel':
                    var label = UTILS.getQueryString('label'),
                        remark = UTILS.getQueryString('remark');
                    curQuery = _.omit(curQuery, ['from', 'label', 'remark']);
                    this.$store.state.embedded.fromEmbedded = true;
                    this.$store.state.embedded.hideTitle = curQuery.hideTitle;
                    this.$store.state.embedded.queryData = curQuery;
                    me.$store.dispatch('label/initLabelList', {
                        cb: function() {
                            me.$store.dispatch('label/initSelectedLabelFromDetail', {
                                label: label, remark: remark
                            });
                            me.$store.dispatch('label/updateComfirmedSelectedLabel');
                        }
                    });
                    break;
                case 'searchlabel':
                    curQuery = _.omit(curQuery, ['from']);
                    this.$store.state.embedded.fromEmbedded = true;
                    this.$store.state.embedded.hideTitle = curQuery.hideTitle;
                    this.$store.state.embedded.queryData = curQuery;
                    this.$store.dispatch('label/initLabelList');
                    this.$store.dispatch('label/updateComfirmedSelectedLabel');
                    break;
                default:
                    break;
            }
        },
        initEmbeddedLabelManage(curQuery) {
            curQuery = _.omit(curQuery, ['from', 'id', 'label', 'remark']);
            this.$store.state.embedded.fromEmbedded = true;
            this.$store.state.embedded.hideTitle = curQuery.hideTitle;
            this.$store.state.embedded.queryData = curQuery;
            this.$store.dispatch('label/initLabelList');
            this.$store.dispatch('label/updateComfirmedSelectedLabel');
        },
        initEmbeddedFamousPediaRead(curQuery) {
            // console.error('initEmbeddedFamousPediaRead--------', curQuery)
            this.$store.state.embedded.fromEmbedded = true;
            this.$store.state.embedded.queryData = curQuery;
            this.$store.dispatch('comment/resetData');
            this.$store.dispatch('search/resetData');
            this.$store.dispatch('minifatefortune/resetMiniData');
            this.$store.dispatch('famouspediacomment/resetData');
            this.$store.dispatch('famouspedia/resetPediaData');
            this.$store.dispatch('famouspedia/initBaikeInfo', {
                baikeId: curQuery.id
            });
        },
        initEmbeddedFamousPediaEdit(curQuery) {
            // console.error('initEmbeddedFamousPediaEdit--------', curQuery)
            var me = this;
            this.$store.state.embedded.fromEmbedded = true;
            this.$store.state.embedded.queryData = curQuery;
            this.$store.dispatch('comment/resetData');
            this.$store.dispatch('search/resetData');
            this.$store.dispatch('minifatefortune/resetMiniData');
            this.$store.dispatch('famouspediacomment/resetData');
            this.$store.dispatch('famouspedia/resetPediaData');
            this.$store.dispatch('famouspedia/initBaikeInfo', {
                fromDetail: false,
                baikeId: curQuery.id,
                baikeType: curQuery.type,
                baikeStatus: curQuery.status,
                sucCb: function(curEditType) {
                    // console.error('curEditType------', curEditType)
                },
                failCb: function() {
                    me.$toast('没有找到这个八字的百科数据');
                }
            })
        },
        initEmbeddedFamousPediaCreate(curQuery) {
            this.$store.state.embedded.fromEmbedded = true;
            this.$store.state.embedded.queryData = curQuery;
            this.$store.dispatch('collate/resetData');
            this.$store.dispatch('collate/initSizhuCollate');
        },
        initEmbeddedDiagram(curQuery) {
            this.$store.state.embedded.fromEmbedded = true;
            this.$store.state.embedded.queryData = curQuery;
            console.log('embedded/diagram=====', curQuery)
        }
    }
}
</script>